module.exports = __webpack_public_path__ + "img/conclusion3.ee73d49e.png";